import Accounts from "./pages/Accounts";


const accountsRoutes = [
    {
        path: "/facilitiy/accounts",
        element: <Accounts />,
    },
];

export default accountsRoutes;